import { createLookupTable } from '../utils';

const statuses = {
  active: 'success',
  prospect: 'info',
  inactive: 'default',
} as const;

export type CustomerLabel = keyof typeof customerStatusTable;
export const customerStatusTable = createLookupTable(statuses, 'customer');
